import { render, staticRenderFns } from "./ValidationHistoryTab.vue?vue&type=template&id=1c85c71e&scoped=true"
import script from "./ValidationHistoryTab.vue?vue&type=script&lang=js"
export * from "./ValidationHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./ValidationHistoryTab.vue?vue&type=style&index=0&id=1c85c71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c85c71e",
  null
  
)

export default component.exports